import Fields from './FieldsContainer';

export default Fields;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Fields/index.js